import { NgModule } from '@angular/core';
import { CallbackPipe } from './callback.pipe';
import { DeHTMLLizePipe } from './de-htmllize.pipe';
import { deNLizePipe } from './de-n-lize';

@NgModule({
	declarations: [CallbackPipe, DeHTMLLizePipe, deNLizePipe],
	imports: [],
	exports: [CallbackPipe, DeHTMLLizePipe, deNLizePipe],
})
export class MspPipesModule {}
